import { createNativeRequest, platform } from '@mx/core';
import { AxiosRequestConfig } from 'axios';

import { request } from '../request';
import {
  IAppSettings,
  ICheckExistsInFirebaseReq,
  ICheckExistsInFirebaseResp,
  ILoginReq,
  ILoginResp,
  ILogoutReq,
  IRefreshAuthTokenReq,
  IRefreshAuthTokenResp,
  ISendVerificationCodeReq,
  ISendVerificationCodeResp,
} from '../types';

export const postLogin = async (
  data: ILoginReq,
  config?: AxiosRequestConfig
): Promise<ILoginResp> => {
  const url = '/weaver/api/v1/account/login';
  return await request.post(url, data, config || {});
};

export const postLogout = async (data: ILogoutReq): Promise<void> => {
  const url = '/weaver/api/v1/account/logout';
  return await request.post(url, data);
};

export const postGetSettings = async (): Promise<IAppSettings> => {
  const url = '/weaver/api/v1/settings/get_app_settings';

  return await request.post(url, {});
};

export const postGetUserStatus = async (): Promise<void> => {
  const url = '/weaver/api/v1/account/get_user_status';

  if (platform.isNativePlatform) {
    return createNativeRequest<void>({
      method: 'POST',
      url,
      data: {},
    });
  }

  return await request.post(url, {});
};

export const postRefreshAuthToken = async (
  data: IRefreshAuthTokenReq
): Promise<IRefreshAuthTokenResp> => {
  const url = '/weaver/api/v1/account/refresh_auth_token';

  return await request.post(url, data);
};

export const postCheckExistsInFirebase = async (
  data: ICheckExistsInFirebaseReq
): Promise<ICheckExistsInFirebaseResp> => {
  const url = '/weaver/api/v1/account/check_exists_in_firebase';

  return await request.post(url, data);
};

export const postSendVerificationCode = async (
  data: ISendVerificationCodeReq
): Promise<ISendVerificationCodeResp> => {
  const url = '/weaver/api/v1/account/send_verification_code';

  return await request.post(url, data);
};

export const postNodeLogin = async (
  data: ILoginReq,
  config?: AxiosRequestConfig
): Promise<ILoginResp> => {
  const url = '/api/login';
  return await request.post(url, data, config || {});
};

// just clear cookies
export const postNodeLogout = async (): Promise<void> => {
  const url = '/api/logout';
  return await request.post(url, {});
};
